import { AxiosInstance } from 'axios';

export const useMockApi = (axiosInstance: AxiosInstance): void => {
  if (
    process.env.REACT_APP_EXPERIENCE_LITE_API_DOMAIN === process.env.REACT_APP_DOMAIN &&
    process.env.NODE_ENV === process.env.REACT_APP_DEV_MODE
  ) {
    if (process.env.REACT_APP_MFS === 'true') {
      import('../../../mockServer/mfsTemplateMock').then((mockUpClient) => {
        mockUpClient.mockUpClient(axiosInstance);
      });
    } else {
      import('../../../mockServer').then((mockUpClient) => {
        mockUpClient.mockUpClient(axiosInstance);
      });
    }
  }
};
